import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-email-changed.component.less'],
  templateUrl: './tellent-email-changed.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentEmailChangedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentEmailChangedTemplateData>;
}

export type TellentEmailChangedTemplateData = {
  avatar_url: string;
  title: string;
  p1: string;
  p2: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
};

export const TellentEmailChangedTemplateMocks: TellentEmailChangedTemplateData[] = [
  {
    avatar_url:
      'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
    title: 'Email address has been changed',
    p1: `Hello %{user_name}! 👋 Your Tellent account email address has been successfully changed to %{email}. We're notifying you at your old email address to ensure you made this change.`,
    p2: 'If this change hasn’t been made by you, please contact our support team.',
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
  },
];
